import { useState } from 'react';
import useMediaQuery from '../hooks/useMediaQuery';
import Reveal from '../components/Reveal';
import { Chevron } from '../components/icons';
import './Services.css';

function Badge({ children }) {
  return <span className="services__badge">{children}</span>;
}

function PriceList({ prices }) {
  return (
    <div className="services__prices">
      <p className="services__prices-label">Cena</p>
      <ul>
        {prices.map((p, i) => (
          <li key={i} className="price-row">
            <span className="price-row__label">{p.label}</span>
            <span className="price-row__leader" aria-hidden="true" />
            <span className="price-row__value">{p.value}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}

function ServiceDetail({ item }) {
  return (
    <div className="services__detail">
      {item.image && (
        <img className="services__photo" src={item.image} alt={item.imageAlt || item.title} />
      )}
      {item.intro && <p>{item.intro}</p>}
      {item.bullets && (
        <ul className="services__bullets">
          {item.bullets.map((b, i) => (
            <li key={i}>{b}</li>
          ))}
        </ul>
      )}
      {item.outro && <p>{item.outro}</p>}
      <PriceList prices={item.prices} />
    </div>
  );
}

function DesktopTabs({ items }) {
  const [active, setActive] = useState(0);
  return (
    <div className="services__cols">
      <div className="services__list" role="tablist" aria-label="Pakalpojumi">
        {items.map((item, i) => (
          <button
            key={i}
            role="tab"
            aria-selected={active === i}
            className={`services__tab ${active === i ? 'is-active' : ''}`}
            onClick={() => setActive(i)}
          >
            <span className="services__num">{String(i + 1).padStart(2, '0')}</span>
            <span className="services__name">
              {item.title}
              {item.badge && <Badge>{item.badge}</Badge>}
            </span>
          </button>
        ))}
      </div>

      <div className="services__panel" role="tabpanel">
        <h3 className="services__panel-title">
          {items[active].title}
          {items[active].badge && <Badge>{items[active].badge}</Badge>}
        </h3>
        <ServiceDetail item={items[active]} />
      </div>
    </div>
  );
}

function MobileAccordion({ items }) {
  const [open, setOpen] = useState(0);
  return (
    <div className="services__accordion">
      {items.map((item, i) => {
        const isOpen = open === i;
        return (
          <div key={i} className={`acc-item ${isOpen ? 'is-open' : ''}`}>
            <button
              className="acc-head"
              aria-expanded={isOpen}
              onClick={() => setOpen(isOpen ? -1 : i)}
            >
              <span className="acc-head__title">
                {item.title}
                {item.badge && <Badge>{item.badge}</Badge>}
              </span>
              <Chevron className="acc-head__chevron" />
            </button>
            <div className="acc-body">
              <div className="acc-body__inner">
                <ServiceDetail item={item} />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default function Services({ id, eyebrow, heading, items, tone = 'plain' }) {
  const isMobile = useMediaQuery('(max-width: 820px)');
  return (
    <section id={id} className={`section services services--${tone}`}>
      <div className="container">
        <Reveal className="services__head">
          <p className="eyebrow">{eyebrow}</p>
          <h2 className="section-title">{heading}</h2>
        </Reveal>

        <Reveal>{isMobile ? <MobileAccordion items={items} /> : <DesktopTabs items={items} />}</Reveal>
      </div>
    </section>
  );
}
